// @flow
import React from 'react';
import type { Node } from 'react';
import { Link } from 'react-router-dom';
import type { LocationShape } from 'react-router-dom';
import styled, { type StyledComponent } from 'styled-components';

import Button, { ButtonType } from '../Button';

type StyledButtonProps = React$ElementConfig<typeof Button>;

export const StyledButton: StyledComponent<StyledButtonProps> = styled(Button)`
  text-decoration: none !important;
`;
const StyledAnchor: StyledComponent<{}> = styled.a`
  text-decoration: none;
`;

type StyledLinkProps = React$ElementConfig<typeof Link>;

const StyledLink: StyledComponent<StyledLinkProps> = styled(Link)`
  text-decoration: none;
`;

export type Props = {
  children?: Node,
  href: string,
  buttonType?: ButtonType,
  text?: Node,
  linkPath?: string | LocationShape,
  buttonProps?: Object,
};

const LinkButton = ({
  children,
  href,
  text,
  linkPath,
  buttonType,
  buttonProps,
  ...other
}: Props) => {
  let linkProps = {
    ...other,
    href,
  };
  let LinkComponent = StyledAnchor;
  if (linkPath) {
    linkProps = {
      ...other,
      to: linkPath,
    };
    LinkComponent = StyledLink;
  }
  return (
    <LinkComponent {...linkProps}>
      <StyledButton buttonType={buttonType} {...buttonProps}>
        {text || children}
      </StyledButton>
    </LinkComponent>
  );
};

LinkButton.defaultProps = {
  text: '',
  href: '',
  buttonType: ButtonType.DEFAULT,
  linkPath: '',
  buttonProps: {},
  children: null,
};

LinkButton.Button = StyledButton;

export default LinkButton;



// WEBPACK FOOTER //
// ../react-lib/src/components/buttons/LinkButton/LinkButton.jsx